import axios, { AxiosResponse } from 'axios';

export interface IVlastneneEmise {
    idsbj: number;
    idbm: string;
    jmeno: string;
    typz: number;
    rosb: string;
}

export interface ISeznamVlastEmisi {
    listissuer: IVlastneneEmise[];
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const vlastneneEmiseApi = (order: string, lang: string, ic: any, typ: string) => {
    return axios({
        method: 'GET',
        url: window.location.origin + `/isbpublicjson/api/Issuer?order=${order}&lang=${lang}&ic=${ic}&typ=${typ}`
    }).then((resp: AxiosResponse<ISeznamVlastEmisi>) => resp.data.listissuer);
};

export default vlastneneEmiseApi;
